
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/data-engineer/[slug]",
      function () {
        return require("private-next-pages/jobs/data-engineer/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/data-engineer/[slug]"])
      });
    }
  